import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Users, ArrowRight, Shield } from "lucide-react";
import CountUp from "./CountUp";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function TriagemCounter() {
  const [total, setTotal] = useState(null);

  useEffect(() => {
    let mounted = true;
    axios.get(`${API}/triagem/count`).then((r) => {
      if (mounted) setTotal(r.data?.total ?? null);
    }).catch(() => {});
    return () => { mounted = false; };
  }, []);

  if (!total) return null;

  return (
    <section
      data-testid="triagem-counter-section"
      className="bg-gradient-to-br from-ga-ink via-ga-ink to-slate-900 text-white section-pad relative overflow-hidden"
    >
      <div className="absolute -top-20 left-1/2 -translate-x-1/2 w-[40rem] h-[40rem] rounded-full bg-ga-emerald/15 blur-3xl pointer-events-none" />
      <div className="container-ga relative text-center">
        <div className="inline-flex items-center gap-2 rounded-full bg-white/10 border border-white/15 px-4 py-1.5 mb-6">
          <Shield className="w-3.5 h-3.5 text-ga-emerald" />
          <span className="text-[11px] uppercase tracking-[0.2em] font-bold text-white/80">Triagem orientativa</span>
        </div>

        <div className="font-display font-black tracking-tighter text-5xl sm:text-7xl lg:text-8xl text-white leading-none tabular-nums" data-testid="triagem-counter-total">
          +<CountUp to={total} duration={1800} />
        </div>

        <div className="mt-4 inline-flex items-center gap-2 rounded-full bg-ga-emerald/15 border border-ga-emerald/30 px-3 py-1" data-testid="triagem-live-badge">
          <span className="relative flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-ga-emerald opacity-75"></span>
            <span className="relative inline-flex rounded-full h-2 w-2 bg-ga-emerald"></span>
          </span>
          <span className="text-[10px] uppercase tracking-[0.2em] font-bold text-ga-emerald">
            Atualizado em tempo real
          </span>
        </div>

        <p className="mt-5 text-white/80 text-lg sm:text-xl max-w-2xl mx-auto leading-relaxed">
          famílias já buscaram <strong className="text-white">orientação conosco</strong>.
          Cada triagem é um primeiro passo para quem estava com dúvidas sobre o desenvolvimento da sua criança.
        </p>

        <div className="mt-8 flex flex-wrap gap-3 justify-center">
          <Link
            to="/triagem"
            data-testid="triagem-counter-cta"
            className="inline-flex items-center gap-2 rounded-full bg-ga-emerald text-white font-bold py-3.5 px-7 hover:bg-ga-amber hover:text-ga-ink transition-colors"
          >
            <Users className="w-4 h-4" />
            Fazer minha triagem agora
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        <p className="mt-5 text-[11px] text-white/40 uppercase tracking-widest">
          Ferramenta gratuita · orientativa · não diagnóstica
        </p>
      </div>
    </section>
  );
}
